var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sky__content-page py-10"},[_c('div',{staticClass:"mx-auto",staticStyle:{"width":"900px","max-width":"100%"},domProps:{"innerHTML":_vm._s(_vm.bodyContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }